export const languages = [
    {
        label: 'Русский',
        value: 'russian'
    },
    {
        label: 'Английский',
        value: 'english'
    },
    {
        label: 'Узбекский',
        value: 'uzbek'
    },
    {
        label: 'Украинский',
        value: 'ukrainian'
    },
    {
        label: 'Казахский',
        value: 'kazakh'
    },
    {
        label: 'Белорусский',
        value: 'belarus'
    },
    {
        label: 'Фарси',
        value: 'farsi'
    },
    {
        label: 'Хинди',
        value: 'hindi'
    },
    {
        label: 'Китайский',
        value: 'chinese'
    },
    {
        label: 'Тамильский',
        value: 'tamil'
    },
    {
        label: 'Амхарский',
        value: 'amhar'
    },
    {
        label: 'Абхазский',
        value: 'abkhaz'
    },
    {
        label: 'Аварский',
        value: 'avar'
    },
    {
        label: 'Азербайджанский',
        value: 'azeri'
    },
    {
        label: 'Албанский',
        value: 'albanian'
    },
    {
        label: 'Арабский',
        value: 'arabic'
    },
    {
        label: 'Армянский',
        value: 'armenian'
    },
    {
        label: 'Башкирский',
        value: 'bashkir'
    },
    {
        label: 'Бенгальский',
        value: 'bengali'
    },
    {
        label: 'Бирманский',
        value: 'birman'
    },
    {
        label: 'Болгарский',
        value: 'bulgarian'
    },
    {
        label: 'Венгерский',
        value: 'hungarian'
    },
    {
        label: 'Вьетнамский',
        value: 'vietnamese'
    },
    {
        label: 'Гавайский',
        value: 'hawaiian'
    },
    {
        label: 'Грузинский',
        value: 'georgian'
    },
    {
        label: 'Гуджарати',
        value: 'gujarati'
    },
    {
        label: 'Датский',
        value: 'danish'
    },
    {
        label: 'Иврит',
        value: 'hebrew'
    },
    {
        label: 'Индонезийский',
        value: 'indonesian'
    },
    {
        label: 'Исландский',
        value: 'icelandic'
    },
    {
        label: 'Испанский',
        value: 'spanish'
    },
    {
        label: 'Итальянский',
        value: 'italian'
    },
    {
        label: 'Каннада',
        value: 'kannada'
    },
    {
        label: 'Каталанский',
        value: 'catalan'
    },
    {
        label: 'Киргизский',
        value: 'kyrgyz'
    },
    {
        label: 'Корейский',
        value: 'korean'
    },
    {
        label: 'Кхмерский',
        value: 'khmer'
    },
    {
        label: 'Латинский',
        value: 'latin'
    },
    {
        label: 'Латышский',
        value: 'latvian'
    },
    {
        label: 'Литовский',
        value: 'lithuanian'
    },
    {
        label: 'Македонский',
        value: 'macedonian'
    },
    {
        label: 'Малайский',
        value: 'malay'
    },
    {
        label: 'Малаялам',
        value: 'malayalam'
    },
    {
        label: 'Маратхи',
        value: 'marathi'
    },
    {
        label: 'Монгольский',
        value: 'mongolian'
    },
    {
        label: 'Немецкий',
        value: 'german'
    },
    {
        label: 'Нидерландский',
        value: 'netherlands'
    },
    {
        label: 'Норвежский',
        value: 'norwegian'
    },
    {
        label: 'Ория',
        value: 'oria'
    },
    {
        label: 'Панджаби',
        value: 'panjabi'
    },
    {
        label: 'Пиджин',
        value: 'pidgin'
    },
    {
        label: 'Польский',
        value: 'polish'
    },
    {
        label: 'Португальский',
        value: 'portuguese'
    },
    {
        label: 'Пушту',
        value: 'pashto'
    },
    {
        label: 'Румынский',
        value: 'romanian'
    },
    {
        label: 'Себуано',
        value: 'cebuano'
    },
    {
        label: 'Сербский',
        value: 'serbian'
    },
    {
        label: 'Сингальский',
        value: 'sinhala'
    },
    {
        label: 'Словацкий',
        value: 'slovak'
    },
    {
        label: 'Словенский',
        value: 'slovene'
    },
    {
        label: 'Сомалийский',
        value: 'somali'
    },
    {
        label: 'Суахили',
        value: 'swahili'
    },
    {
        label: 'Тагалог',
        value: 'tagalog'
    },
    {
        label: 'Таджикский',
        value: 'tajik'
    },
    {
        label: 'Тайский',
        value: 'thai'
    },
    {
        label: 'Татарский',
        value: 'tatar'
    },
    {
        label: 'Телугу',
        value: 'telugu'
    },
    {
        label: 'Турецкий',
        value: 'turkish'
    },
    {
        label: 'Туркменский',
        value: 'turkmen'
    },
    {
        label: 'Урду',
        value: 'urdu'
    },
    {
        label: 'Уэльский',
        value: 'welsh'
    },
    {
        label: 'Филиппинский',
        value: 'filipino'
    },
    {
        label: 'Финский',
        value: 'finnish'
    },
    {
        label: 'Французский',
        value: 'french'
    },
    {
        label: 'Хауса',
        value: 'hausa'
    },
    {
        label: 'Хорватский',
        value: 'croatian'
    },
    {
        label: 'Чеченский',
        value: 'chechnya'
    },
    {
        label: 'Чешский',
        value: 'czech'
    },
    {
        label: 'Шведский',
        value: 'swedish'
    },
    {
        label: 'Эсперанто',
        value: 'esperanto'
    },
    {
        label: 'Эстонский',
        value: 'estonian'
    },
    {
        label: 'Якутский',
        value: 'yakut'
    },
    {
        label: 'Японский',
        value: 'japanese'
    }
]
